import {
  CCard,
  CCardBody,
  CCardFooter,
  CCardGroup,
  CCardHeader,
  CCardImg,
  CCol,
  CContainer,
  CLink,
  CRow,
} from "@coreui/react";

import { MonitorHeart } from "@mui/icons-material";
import PropTypes from "prop-types";
import React from "react";
import { Can } from "src/helpers/Auth";

const authorized_products = [
  {
    disp_name: "Dataset Scoring",
    src: "./images/product-logos/wrkmgmt.png",
    name: "scoring-wizard",
    detail: "Score and analyze your trendcode data.",
    role: "dataset_data:read",
  },
  {
    disp_name: "Outage Analysis",
    src: "./images/product-logos/calendar_blue_green.png",
    name: "project-genius-wizard",
    detail: "Analyze your outage files using Monte Carlo analysis.",
    role: "project_genius:read",
  },
  {
    disp_name: "Proposal Generation",
    src: "./images/product-logos/ATOMASSIST.png",
    name: "proposal-generation",
    to: "/proposal-generation",
    detail: "Generate proposals quickly with AI assistance.",
    role: "model:read",
  },
  {
    disp_name: "Equipment AI",
    icon: <MonitorHeart color="primary" sx={{ fontSize: 120 }} />,
    name: "equipment-ai",
    detail: "Monitor equipment health and PM frequency compliance.",
    role: "equipment_ai:read",
  },
  {
    disp_name: "50.59 Evaluation",
    src: "./images/product-logos/ATOMASSIST.png",
    name: "licensing-compliance",
    to: "/fifty-fifty-nine",
    detail: "Agent-driven 10 CFR 50.59 reviews with persistent records.",
    role: "product:read",
  },
];

// <Can
//           perform={item._roles}
//           key={idx}
//           yes={() =>
//             React.createElement(
//               this.props.components[item._tag],
//               { ...item, key: idx },
//               item._children
//             )
//           }
//           no={() => {
//             return <></>;
//           }}
//         />
export default class WorkflowView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { authorized_products: authorized_products };
  }

  render() {
    return (
      <CContainer
        data-testid="prod-container"
        fluid
        style={{ marginTop: "1%" }}
      >
        <CCardGroup>
          <CRow style={{ width: "100%" }}>
            {this.state.authorized_products.map((ap) => (
              // Route guard uses the most-limiting permission for this product.
              <Can
                key={ap.name}
                perform={ap.role}
                yes={() => <WorkflowCard ap={ap} />}
                no={() => <WorkflowCard ap={ap} disabled />}
              />
            ))}
          </CRow>
        </CCardGroup>
      </CContainer>
    );
  }
}

WorkflowView.propTypes = {
  ap: PropTypes.shape({
    name: PropTypes.string,
  }),
};

export class WorkflowCard extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <CCol
        xs="12"
        sm="8"
        md="6"
        lg="3"
        xl="3"
        style={{ filter: this.props.disabled ? "grayscale(100%)" : "none" }}
      >
        <CLink
          data-testid={`prod-link-${this.props.ap.name}`}
          className={"card-link"}
          to={this.props.ap.to || "/products/" + this.props.ap.name}
        >
          <CCard
            className={
              "workflow-card d-flex align-items-stretch product-card-" +
              this.props.ap.name
            }
            borderColor=""
            align="center"
          >
            <CCardBody>
              <ProductLogo src={this.props.ap.src} icon={this.props.ap.icon} />
            </CCardBody>
            <CCardFooter borderColor="white">
              <div>
                <div>
                  <strong>{this.props.ap.disp_name}</strong>
                </div>
                <div>
                  <small>{this.props.ap.detail}</small>
                </div>
              </div>
            </CCardFooter>
          </CCard>
        </CLink>
      </CCol>
    );
  }
}

WorkflowCard.propTypes = {
  ap: PropTypes.shape({
    name: PropTypes.string,
    disp_name: PropTypes.string,
    src: PropTypes.string,
    icon: PropTypes.node,
    detail: PropTypes.string,
    to: PropTypes.string,
  }),
  disabled: PropTypes.bool,
};

const ProductLogo = ({ src, icon }) => {
  if (icon) {
    return (
      <div className="d-flex justify-content-center card-img-top">{icon}</div>
    );
  }
  return (
    <CCardImg
      className="rounded mx-auto d-block card-img-top"
      variant="full"
      src={src}
      shape="rounded"
    />
  );
};

ProductLogo.propTypes = {
  src: PropTypes.string,
  icon: PropTypes.node,
};

export function PredictorTable() {
  return (
    <CRow>
      <CCol xs="12" sm="6" md="4">
        <CCard>
          <CCardHeader>Card title</CCardHeader>
        </CCard>
      </CCol>
    </CRow>
  );
}
